import { useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from '../PdfRenderer.module.scss';

interface NotePopupProps {
    note: string;
    x: number;
    y: number;
    yBottom?: number;
    autoFocus: boolean;
    onChange: (note: string) => void;
    onDelete: () => void;
    onClose: () => void;
    onFocus: () => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
}

export function NotePopup({
    note,
    x,
    y,
    yBottom,
    onDelete,
    onClose,
    onMouseEnter,
    onMouseLeave
}: NotePopupProps) {
    const ref = useRef<HTMLDivElement>(null);
    const [dir, setDir] = useState<'up' | 'down'>('up');
    const [pos, setPos] = useState({ left: x, top: y });

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return;
        const parent = el.offsetParent as HTMLElement | null;
        if (!parent) return;

        const popupH = el.offsetHeight;
        const popupW = el.offsetWidth;
        const parentH = parent.offsetHeight;
        const parentW = parent.offsetWidth;

        const anchorBottom = yBottom ?? y;
        const topIfUp = y - popupH - 10;
        const bottomIfDown = anchorBottom + 10 + popupH;
        const flipped = topIfUp < 0 && bottomIfDown <= parentH;

        setDir(flipped ? 'down' : 'up');

        // Горизонтальный clamp
        const halfW = popupW / 2;
        let left = x;
        if (left - halfW < 0) left = halfW;
        if (left + halfW > parentW) left = parentW - halfW;

        setPos({ left, top: flipped ? anchorBottom : y });
    }, [x, y, yBottom]);

    return (
        <div
            ref={ref}
            data-note-popup
            className={clsx(styles.popup, dir === 'down' && styles['popup--down'])}
            style={{ left: `${pos.left}px`, top: `${pos.top}px` }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className={styles.popup__header}>
                <button
                    type="button"
                    className={styles.popup__close}
                    aria-label="Закрыть"
                    onClick={onClose}
                >
                    <i className="fa-solid fa-xmark" />
                </button>
            </div>
            {note ? (
                <div
                    className={styles.popup__content}
                    dangerouslySetInnerHTML={{ __html: note }}
                />
            ) : (
                <p className={styles.popup__empty}>Нет комментария</p>
            )}
            <div className={styles.popup__actions}>
                <button type="button" className={styles.popup__delete} onClick={onDelete}>
                    <i className="fa-solid fa-trash" />
                    Удалить
                </button>
            </div>
        </div>
    );
}
